/**
 * workdayNav.js
 *
 * Navigation shortcuts used by the Munkanap UI (sheet, reminder modal, briefing card). Guarded so navigating can never
 * throw when the navigator is not ready or a route is not part of this build.
 *
 * @module helpers/workdayNav
 */

import {navigationRef} from './navigationRef';

/** Route of the Time Tracker screen. */
export const TIME_TRACKER_ROUTE = 'TimeTrackerScreen';

/**
 * @param {string} name route name.
 * @returns {boolean} whether the root navigator declares the route.
 */
export const rootHasRoute = (name) => {
    try {
        return navigationRef.isReady() && !!navigationRef.getRootState()?.routeNames?.includes(name);
    } catch (_e) {
        return false;
    }
};

/**
 * Open the Time Tracker screen.
 * @returns {boolean} true when navigation was dispatched.
 */
export const openTimeTracker = () => {
    if (!rootHasRoute(TIME_TRACKER_ROUTE)) {
        return false;
    }

    try {
        navigationRef.navigate(TIME_TRACKER_ROUTE);

        return true;
    } catch (_e) {
        return false;
    }
};
